import { literal, nullable, number, object, string } from "superstruct";

export const RewardsFreeProductSchema = object({
    type: literal("free_product"),
    discountValue: number(),
    productId: number(),
    productHandle: string(),
    productTitle: string(),
    productImage: nullable(string()),
});
